module.exports = __webpack_public_path__ + "static/media/upi.1ab16e80.svg";